import { render, staticRenderFns } from "./addactiver.vue?vue&type=template&id=53a99bdd&scoped=true"
import script from "./addactiver.vue?vue&type=script&lang=js"
export * from "./addactiver.vue?vue&type=script&lang=js"
import style0 from "./addactiver.vue?vue&type=style&index=0&id=53a99bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a99bdd",
  null
  
)

export default component.exports